/**
 * Single formatter for every figure shown to a reader.
 * Ratios 2dp · multiples 1dp with × · percentages 1dp · currency 0dp with separators.
 */

function isMissing(value) {
  return value === null || value === undefined || Number.isNaN(Number(value));
}

export function formatRatio(value) {
  if (isMissing(value)) return 'Not computable';
  return Number(value).toFixed(2);
}

export function formatMultiple(value) {
  if (isMissing(value)) return 'Not computable';
  return `${Number(value).toFixed(1)}\u00d7`;
}

export function formatPercent(value) {
  if (isMissing(value)) return 'Not computable';
  return `${Number(value).toFixed(1)}%`;
}

export function formatCurrency(value, { currencySymbol = '$' } = {}) {
  if (isMissing(value)) return 'Not computable';
  const n = Math.round(Number(value));
  const abs = Math.abs(n).toLocaleString('en-US');
  return n < 0 ? `-${currencySymbol}${abs}` : `${currencySymbol}${abs}`;
}

export function formatAxisTick(value, { percent = false } = {}) {
  if (isMissing(value)) return '';
  if (percent) return formatPercent(value);
  return formatRatio(value);
}

export function formatFigure(value, kind = 'ratio') {
  switch (kind) {
    case 'multiple':
      return formatMultiple(value);
    case 'percent':
      return formatPercent(value);
    case 'currency':
      return formatCurrency(value);
    case 'ratio':
    default:
      return formatRatio(value);
  }
}

export function displayRatio(value, reason) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return reason ? `Not computable (${reason})` : 'Not computable';
  }
  return formatRatio(value);
}

export default formatFigure;
